import { useCreateInitialAgent } from '@/pages/agents/hooks';
import { AppRoutes } from '@/utils/types';
import { AgentCreateTabType, Presenter } from '@d-id/types';
import { useNavigate } from 'react-router-dom';
import { atom, useRecoilState } from 'recoil';

const navigatingToAgentsEditor = atom<boolean>({
    key: 'navigating-to-agents-editor',
    default: false,
});

interface Props {
    agentId: string;
    from?: string | null;
    mixPanelFrom?: string;
    initialAvatar?: Presenter;
    wasEmbedded?: boolean;
}

export const useNavigateToAgentsEditor = () => {
    const navigate = useNavigate();
    const { createInitialAgent } = useCreateInitialAgent();

    const [isLoading, setIsLoading] = useRecoilState(navigatingToAgentsEditor);

    const navigateToAgentEditor = async (props: Partial<Props>) => {
        if (isLoading) return;

        setIsLoading(true);

        if (props.agentId) {
            navigate(AppRoutes.AgentEditor + '/' + props.agentId, { state: props });
            setIsLoading(false);
            return;
        }

        const agent = await createInitialAgent(props.initialAvatar);
        if (agent?.id) {
            navigate(AppRoutes.AgentEditor + '/' + agent.id, {
                state: {
                    ...props,
                    initialTab: props.initialAvatar ? AgentCreateTabType.Details : undefined,
                },
            });
            setIsLoading(false);
            return;
        }

        navigate(AppRoutes.Agent);
        setIsLoading(false);
    };

    return { navigateToAgentEditor, isLoading };
};
